import React, { lazy } from 'react';
import { Route } from 'react-router';
import Authenticated from '../../components/auth/Authenticated';
import routes from '../routes';

const ConversationStarterListScreen = lazy(() => import('../../screens/ConversationStarter/screens/List'));
const ConversationStarterViewScreen = lazy(() => import('../../screens/ConversationStarter/screens/View'));
const ConversationStarterCreateScreen = lazy(() => import('../../screens/ConversationStarter/screens/Create'));
const ConversationStarterEditScreen = lazy(() => import('../../screens/ConversationStarter/screens/Edit'));

const conversationStarterRoutes = [
    <Route
        exact
        key={routes.CONVERSATION_STARTER_LIST}
        path={routes.CONVERSATION_STARTER_LIST}
        render={() => (
            <Authenticated>
                <ConversationStarterListScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.CONVERSATION_STARTER_VIEW}
        path={routes.CONVERSATION_STARTER_VIEW}
        render={() => (
            <Authenticated>
                <ConversationStarterViewScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.CONVERSATION_STARTER_CREATE}
        path={routes.CONVERSATION_STARTER_CREATE}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <ConversationStarterCreateScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.CONVERSATION_STARTER_EDIT}
        path={routes.CONVERSATION_STARTER_EDIT}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <ConversationStarterEditScreen />
            </Authenticated>
        )}
    />,
];

export default conversationStarterRoutes;
